


















































































































import { Component, Mixins, Watch, Emit, Vue } from "vue-property-decorator";
import { TextBoxItem } from "../../../../domain/document/items";
import { NumericFormatKinds, NumericInputFormatter } from "../../../../domain/document";
import FilterableTextInput from "../../../drawing/FilterableTextInput.vue";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { TextObjectStyleReader } from "../styleReaders";
import {
  StyledTextEditableObjectMixin,
  DataValidatableMixin,
  ImeControllableMixin,
  UserDefinitionSelectableMixin,
  ExternalTemplateInputtableMixin,
} from "./mixins";
import { TextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { FontSizeCalculator } from "../../../../domain/drawing";
import { ImelessTextarea } from "../../../system";

@Component({
  components: {
    FilterableTextInput,
    ImelessTextarea,
  },
})
export default class TextBoxObject extends Mixins(
  StyledTextEditableObjectMixin,
  DataValidatableMixin,
  ImeControllableMixin,
  UserDefinitionSelectableMixin,
  ExternalTemplateInputtableMixin,
) {
  @Emit()
  updateInputElement(element: HTMLInputElement): void {}

  mounted(): void {
    this.updateInputElement(this.getActiveInputElement());
  }

  get clickChainedObjectPrivateId(): number {
    return this.editingSource.clickChainedObjectPrivateId;
  }

  get isObjectVisible(): boolean {
    return !!this.clickChainedObjectPrivateId || this.isVisible;
  }

  getActiveInputElement(): HTMLInputElement {
    if (this.shouldInputText || (!this.isInputableText && this.isMultiLine)) {
      return !!this.$refs.imelessTextarea
        ? (this.$refs.imelessTextarea as ImelessTextarea).getEditor() as unknown as HTMLInputElement
        : this.$refs.textarea as HTMLInputElement;
    } else if (this.shouldInputNumber) {
      return (this.$refs.numericInput as Vue).$el as HTMLInputElement;
    } else if (this.shouldInputMoney) {
      return this.$refs.moneyInput as HTMLInputElement;
    } else {
      return null;
    }
  }

  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new TextObjectStyleReader(configuration.style.document.editor.objects.textBox);
  }

  editingSource: TextBoxItem;

  get isObjectNameDisplay(): boolean {
    if (!this.editingSource.isEmpty || this.shouldInputFreeSelfOrAll) { return false; }
    return !!this.editingSource.userDefinitionKey;
  }

  get inputTabIndex(): number {
    // TODO:入力不可でもタブでフォーカスが移動してしまうため、tabindexでフォーカスを制御しています
    // 今回はH大向けに必要最低限の修正としています
    return this.isInputableText ? 0 : -1;
  }

  @Watch("isObjectNameDisplay")
  onIsObjectNameDisplayChanged(newValue: boolean, oldValue: boolean): void {
    this.$nextTick(() => {
      this.updateInputElement(this.getActiveInputElement());
    });
  }

  onFocus(): void {
    if (this.editingSource.isFocusable) {
      this.emitFocus();
    }
    // IEではreadonlyのtextareaでもカーソルが表示されてしまう。
    // 対策としてここで(shouldInputFreeSelfOrAll===falseの場合)focusを外していたが、IEだとfocus外すと、activeElementになるbodyからタブ遷移してしまう。
    // (chromeはactiveElementはbodyになるもののタブフォーカスは維持されてるのかちゃんと動く。)
    // タブ順がおかしくなるのは文書入力ソフトとしては致命的なのでreadonlyでもフォーカスが出るのは諦める。
  }

  onClicked(): void {
    if (this.clickChainedObjectPrivateId) {
      this.commonComponents.agents.clickChain.chain();
    }
  }

  onDrop(event: DragEvent): void {
    // 入力対象以外は親に処理を任せる
    if (this.shouldInputText) {
      this.onDropFreeInput(event, this.emitFocus);
    }
  }

  onObjectNameDisplayClicked(): void {
    // フォーカスが当たらないとdebug表示されなくて不便なので対策している
    const container = this.$refs.objectNameContainer as HTMLDivElement;
    if (container) {
      container.focus();
      this.emitFocus();
    }
    this.$nextTick(() => {
      const element = this.getActiveInputElement();
      if (element) { element.focus(); }
      this.showDialogForSpecificObject();
    });
  }

  get titleWithLengthDescription(): string {
    return this.appendLengthDescription(this.title, this.editingSource);
  }

  get title(): string {
    if (this.toolTip) {
      return this.toolTip;
    }
    if (this.editingSource.isNote) {
      // 自動続紙追加で値が入ってくる領域
      // 元のオブジェクトの名称を表示する？
      // TODO:V1の仕様の確認
      return "備考";
    }
    return this.objectName;
  }
  
  get freeInputText(): string {
    if (this.shouldInputMoney && this.isFocused) {
      // フォーカスが当たっているときにDOMの値をカンマ有りの形式に自動更新するとカーソルが文の末尾に行ってしまうので、
      // フォーカスが当たっているときはDOMの値を返却して表示を更新させないようにしている
      return this.getMoneyEditingText();
    }
    return this.editingSource.value;
  }

  set freeInputText(value: string) {
    const formattedValue = this.shouldInputMoney
      ? NumericInputFormatter.format(value, this.editingSource.numericFormat)
      : value;
    this.writeProperty((s: TextBoxItem) => {
      const newValue = this.validateText(this.editingSource, formattedValue);
      if (this.isFreeInputable && this.isFreeInputOverwrittenByAll && this.isFocused && s.value !== newValue) {
        // 「全てフリー入力」の状態で手入力された場合はフリー入力に切り替える
        s.shouldInputFree = true;
      }
      s.value = newValue;
      if (s.shouldAutoAdjustHeight) {
        s.geometry.rectangle.size.height = FontSizeCalculator.calculateObjectHeight(s);
      }
      // ユーザ定義のリンク値は登録前に辻褄を合わせる挙動になっている
      // フリー入力されたら一律でクリアする
      s.linkedValue = "";
    });
  }

  get freeInputMeasureText(): string {
    this.updateTextPositionHeight();
    return this.textPositionCompositing
      ? this.textPositionMeasureText
      : this.freeInputText;
  }

  getMoneyEditingText(): string {
    const moneyInput = this.$refs.moneyInput as HTMLInputElement;
    if (!moneyInput) { return this.editingSource.value; }
    
    // 基本的には差異は出ないはずだが、実際の挙動はDOMのふるまいに依存するので、念のため値が一致するか確認している
    return NumericInputFormatter.format(moneyInput.value, this.editingSource.numericFormat) === this.editingSource.value
      ? moneyInput.value
      : this.editingSource.value;
  }
  
  get filterableTextInputClass(): string {
    return this.shouldInputNumber
      ? "text-box-object-textarea text-box-object-numeric"
      : "text-box-object-textarea";
  }

  get validExpressions(): string {
    return this.shouldInputNumber
      ? "0-9\\.\\-,"
      : "";
  }

  /**
   * 登録時のボタンクリックのイベントと発生タイミングがかちあうので注意が必要
   */
  onBlur(): void {
    if ((!this.editingSource.isEmpty || this.editingSource.textStyle.isAdjustedFontSize) && !this.editingSource.shouldAutoAdjustHeight) { 
      this.autoAdjustFontSizeWithRetry();
    }
  }

  get shouldInputText(): boolean {
    return !this.editingSource.isNumeric && this.isInputableText;
  }

  get shouldInputNumber(): boolean {
    return this.editingSource.isNumeric && this.isInputableText && this.editingSource.numericFormat !== NumericFormatKinds.Money;
  }

  get shouldInputMoney(): boolean {
    return this.editingSource.isNumeric && this.isInputableText && this.editingSource.numericFormat === NumericFormatKinds.Money;
  }

  get isInputableText(): boolean {
    return this.isFreeInputable && this.shouldInputFreeSelfOrAll;
  }

  get isMultiLine(): boolean {
    return !!this.editingSource.isMultiLine;
  }

  get objectName(): string {
    if (this.editingSource.userDefinitionKey) {
      return this.editingSource.itemName;
    }
    return this.editingSource.isHisInfo
      ? this.editingSource.displayName
      : this.editingSource.name;
  }

  showDialogForSpecificObject(): void {
    if (this.editingSource.userDefinitionKey && !this.shouldInputFreeSelfOrAll) {
      this.selectUserDefinition();
      return;
    }
    if (!this.shouldInputFreeSelfOrAll) {
      this.inputExternalTemplateWhenNeeded();
      return;
    }
  }

  get inputMethodKind(): TextBoxInputMethodKinds {
    return this.editingSource.inputMethodKind;
  }
  
  @Watch("inputMethodKind")
  updatedInputMethodKind(newValue: TextBoxInputMethodKinds, oldValue: TextBoxInputMethodKinds): void {
    if (newValue !== TextBoxInputMethodKinds.UserDefinitionSelect && oldValue !== TextBoxInputMethodKinds.FreeInput) {
      // IEはいったんinputからフォーカスを外さないとreadonlyの制御が反映されない模様
      // 暫定対策で、他の要素にフォーカスを当てている
      this.$nextTick(() => {
        const element = this.getActiveInputElement();
        if (element == null) { return; }
        element.blur();
        element.focus();
        this.showDialogForSpecificObject();
      });
    }
  }

  @Watch("shouldInputFreeSelfOrAll")
  onShouldInputFreeChanged(newValue: boolean, oldValue: boolean): void {
    if (!this.isFreeInputable) { return; }
    if (!this.isFocused) { return; }
    if (!newValue) { return; }
    // IEでは、いったんマウスクリックさせるかフォーカス外さないとreadonlyの切り替えが反映されない模様
    this.$nextTick(() => {
      const element = this.getActiveInputElement();
      if (element == null) { return; }
      element.blur();
      element.focus();
      element.select();
    });
  }

  get pointerStyleProperties(): any {
    return this.shouldIgnorePointer
      ? { pointerEvents: "none" }
      : null;
  }

  get visibleStyleProperties(): any {
    return this.clickChainedObjectPrivateId && !this.isVisible
      ? { opacity: 0 }
      : null;
  }

  get shouldIgnorePointer(): boolean {
    try {
      if (this.isFocused || this.isInputableText || this.editingSource.isFocusable) { return false; }
      // V1は背景色が透過でなくてもクリック透過させている
      // V3でも同様にするべきかは検討が必要
      return (!this.editingSource.paintStyleOnEditing || this.editingSource.paintStyleOnEditing.color.value === "transparent");
    } catch (e) {
      // エラーは発生させないようにしているが念のため
      return false;
    }
  }
}
